export const VideoOnCross = 'https://player.vimeo.com/video/510317462';
export const HomePageVideo = 'https://vimeo.com/524161056';
export const GiftSubscriptionUrl = 'https://www.splashlearn.com/gift';
export const DownloadAppPostTrialStartAppStore = 'https://apps.apple.com/app/apple-store/id672658828?pt=481348&ct=PostTrialStart_QRCode&mt=8';
export const DownloadAppDesktopDashboardAppStore = 'https://apps.apple.com/app/apple-store/id672658828?pt=481348&ct=DesktopDashboard_QRCode&mt=8';
export const DownloadAppParentDashboardAppStore = 'https://apps.apple.com/app/apple-store/id672658828?pt=481348&ct=ParentDashboard_CTA&mt=8';
export const DownloadAppPostTrialStartPlayStore = 'https://play.google.com/store/apps/details?id=com.splash.kids.education.learning.games.free.multiplication.reading.math.grade.app.splashmath&referrer=utm_source=Web&utm_medium=PostTrialStart&utm_term=QRCode'
export const DownloadAppDesktopDashboardPlayStore = 'https://play.google.com/store/apps/details?id=com.splash.kids.education.learning.games.free.multiplication.reading.math.grade.app.splashmath&referrer=utm_source=Web&utm_medium=DesktopDashboard&utm_term=QRCode'
export const DownloadAppParentDashboardPlayStore = 'https://play.google.com/store/apps/details?id=com.splash.kids.education.learning.games.free.multiplication.reading.math.grade.app.splashmath&referrer=utm_source=Web&utm_medium=ParentDashboard&utm_term=CTA'
export const CrossappDownloadPlayStore = 'https://play.google.com/store/apps/details?id=com.splash.kids.education.learning.games.free.multiplication.reading.math.grade.app.splashmath&utm_campaign=crossapp_download_playstorebutton'
export const CrossappDownloadAppStore = 'https://apps.apple.com/app/apple-store/id672658828?pt=481348&ct=crossapp_download_appstorebutt&mt=8'

// [AI GENERATED CODE] Shared store URLs object used by app-download screens
export const appStoreUrls = {
    android: CrossappDownloadPlayStore,
    ios: CrossappDownloadAppStore
};

export const TutoringPitchVideo = 'https://vimeo.com/424330183';
export const mpsGameInviteSuscribeUrl = (studentId) => {
    return `/user/${studentId}/invite`
};
export const TutoringVideo = 'https://player.vimeo.com/video/715231609?h=1b9bcc6998&speed=0&autoplay=1&app_id=122963';
export const gameInviteWebSocketUrl = (studentId) => {
    return `${BASE_WEBSOCKET_GATEWAY_URL}/mps/ws-invites?student_id=${studentId}`;
};

export const PitchPageWithAgeGate = '/upgrade-pitch?ageGate=true';
export const PitchPageWithoutAgeGate = '/upgrade-pitch';

const origin = location.origin;

// Function to get host name based on the current location
export const getHostName = (origin) => {
  const host = location.host?.split('.')[0];
  switch (host) {
    case 'staging':
    case 'staging-play':
    case 'staging-1':
    case 'staging-uk':
    case 'staging-au': {
      return 'staging-1'
    }
    case 'staging-2':
    case 'staging-2-play':{
      return 'staging-2'
    }
    case 'staging-3':
    case 'staging-3-play': {
      return 'staging-3'
    }
    case 'staging-qa':{
      return 'staging-qa'
    }
    case 'f2':
    case 'f2-play': {
      return 'f2'
    }
    case 'preprod':
    case 'preprod-play':
    case 'preprod-uk':
    case 'preprod-au': {
      return 'preprod'
    }
    default: {
      return 'production'
    }
  }
};

// Function to fetch hash key from environment
export const getHashKeyFromEnv = async (hostName) => {
  const apiUrl =
    hostName === 'production'
      ? 'https://pre-prod-splashmath.s3.us-east-1.amazonaws.com/flutter_build/production/build/web/hash_history.json'
      : `https://staging-splashmath-skill-images.s3.us-east-1.amazonaws.com/flutter_build/${hostName}/build/web/hash_history.json`;

  try {
    const response = await fetch(apiUrl);
    if (!response.ok) throw new Error("Network response was not ok");
    const data = await response.json();
    return data?.current?.hash || "";
  } catch (error) {
    console.error("Error fetching hash:", error);
    return "";
  }
};

// [AI GENERATED CODE]
// Async function to get the final Flutter CDN URL with fallback to backup build
export const FlutterBuildCDNUrl = async (origin) => {
  const hostName = getHostName(origin);
  const hash = await getHashKeyFromEnv(hostName);
  const authToken = window.auth_token;

  // If hash is not available or blank, use the backup build path
  if (!hash) {
    console.warn('Hash not available, using backup build path');
    const backupUrl = `${origin}/flutter_build/${hostName}/backup/web/index.html`;
    return authToken ? `${backupUrl}?auth_token=${authToken}` : backupUrl;
  }

  const baseUrl = `${origin}/flutter_build/${hostName}/${hash}/web/index.html`;
  return authToken ? `${baseUrl}?auth_token=${authToken}` : baseUrl;
};

export const FlutterBuildPitstopCDNUrl = `${origin}/flutter_pitstop_build/${getHostName(origin)}/build/web/index.html`;